import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SponsorsStateService {

    public isSponsorFooterDisplayed = new BehaviorSubject<boolean>(false);

    public showSponsorFooter(): void {
        this.isSponsorFooterDisplayed.next(true);
    }

    public hideSponsorFooter(): void {
        this.isSponsorFooterDisplayed.next(false);
    }
}